import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Save, Send, Image } from 'lucide-react';

// Simula la obtención de datos del estudio a partir de su ID
const getStudyData = (studyUID) => {
    const mockStudies = {
        '1.2.3.4.5': { patientName: 'Pérez, Juan', studyDescription: 'RX TÓRAX PA Y LATERAL' },
        '6.7.8.9.0': { patientName: 'García, María', studyDescription: 'USG ABDOMINAL' },
        '1.3.5.7.9': { patientName: 'López, Carlos', studyDescription: 'TC CRÁNEO SIMPLE' },
    };
    return mockStudies[studyUID] || { patientName: 'Desconocido', studyDescription: 'Estudio no encontrado' };
};

const ReportingPage = () => {
    const { studyUID } = useParams();
    const studyData = getStudyData(studyUID);

    return (
        <div className="flex h-screen bg-slate-100 font-sans">
            {/* Panel del Visor DICOM */}
            <div className="w-2/3 bg-black flex flex-col text-white">
                <div className="p-4 bg-gray-900 flex justify-between items-center">
                    <div>
                        <h2 className="text-lg font-bold">{studyData.patientName}</h2>
                        <p className="text-sm text-gray-400">{studyData.studyDescription}</p>
                    </div>
                    <Link to="/worklist" className="flex items-center text-gray-300 hover:text-white transition-colors text-sm">
                        <ArrowLeft size={16} className="mr-1" />
                        Regresar al Worklist
                    </Link>
                </div>
                <div className="flex-1 flex items-center justify-center">
                    <div className="text-center text-gray-500">
                        <Image size={64} className="mx-auto mb-4" />
                        <p>Componente del Visor DICOM (OHIF/Cornerstone)</p>
                        <p className="text-xs">se integrará aquí.</p>
                    </div>
                </div>
            </div>

            {/* Panel de Reporte */}
            <div className="w-1/3 bg-white flex flex-col border-l border-gray-300">
                <div className="p-4 border-b">
                    <h2 className="text-xl font-bold text-gray-800">Interpretación Radiológica</h2>
                </div>
                <div className="flex-1 p-6 overflow-y-auto">
                    <div className="mb-6">
                        <label htmlFor="findings" className="block text-sm font-bold text-gray-700 mb-2">Hallazgos</label>
                        <textarea
                            id="findings"
                            rows="12"
                            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Describa los hallazgos encontrados en el estudio..."
                        ></textarea>
                    </div>
                    <div>
                        <label htmlFor="impression" className="block text-sm font-bold text-gray-700 mb-2">Impresión Diagnóstica</label>
                        <textarea
                            id="impression"
                            rows="6"
                            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Conclusión o diagnóstico principal..."
                        ></textarea>
                    </div>
                </div>
                <div className="p-4 border-t flex justify-end space-x-4 bg-gray-50">
                    <button className="flex items-center bg-gray-200 text-gray-700 px-6 py-2 rounded-lg font-semibold hover:bg-gray-300 transition-colors">
                        <Save size={18} className="mr-2" />
                        Guardar Borrador
                    </button>
                    <button className="flex items-center bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-700 transition-colors shadow-md">
                        <Send size={18} className="mr-2" />
                        Finalizar y Firmar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReportingPage;